import Tick from '@assets/icons/tick.svg'
import Warning from '@assets/icons/warning.svg'
import { useFormContext } from 'react-hook-form'
import { twMerge } from 'tailwind-merge'

type Props = {
  name: string
  label: string
  helper?: string
  optional?: boolean
}

const TelInput = ({ name, label, helper, optional, ...rest }: Props) => {
  const { register, getFieldState, formState } = useFormContext()
  const { error, isTouched, isDirty } = getFieldState(name, formState)

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2"
      data-gt-name="componentevent"
    >
      <div className="md:col-span-2 lg:col-span-1">
        <label className="block" htmlFor={name}>
          <span className="inline-block text-base-text mb-1">
            {label}{' '}
            {optional && (
              <span className="text-xs lowercase whitespace-nowrap">
                (optional)
              </span>
            )}
          </span>
          <div className="relative">
            <input
              id={name}
              className={twMerge(
                `rounded-input border-input-border block w-full p-[0.7rem] pr-12`,
                error && 'border-red',
                !error && isTouched && isDirty && 'border-green',
              )}
              type="tel"
              aria-invalid={error ? 'true' : 'false'}
              maxLength={11}
              data-gt-action="tel-input-interaction"
              data-gt-label={name}
              {...register(name)}
              {...rest}
            />
            {error && (
              <Warning className="absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red" />
            )}
            {!error && isTouched && isDirty && (
              <Tick className="absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green" />
            )}
          </div>
        </label>
        {error && (
          <p className="text-red text-tiny mt-1" role="alert">
            {error.message}
          </p>
        )}
      </div>
      <div className="mt-1 md:mt-8 flex items-center md:min-h-[50px]">
        {helper && <p className="text-tiny leading-5">{helper}</p>}
      </div>
    </div>
  )
}

export default TelInput
